import React from "react";
import { useAppSelector } from "../../../../../store/hooks/StoreHooks";
import {
    Chart,
    ChartArea,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartXAxis,
    ChartYAxis,
    ChartXAxisItem,
    ChartYAxisItem,
    ChartTooltip,
    ChartTitle,
} from "@progress/kendo-react-charts";

import {
    MotorDto, MotorInput,
    MotorOilType_WARNINGDto, MotorPerformanceDto, MotorPerformancePlotData
} from "../../../../../../src/store/model/calculations/motor";


interface MotorPerformanceGraphDataProps {
    data: any | null;
    motor: string
}


const MotorPerformanceGraph: React.FC<MotorPerformanceGraphDataProps> = ({ data, motor }) => {
    if (!data) return <div>No data available</div>;
    return (

        <Chart className="height-max flex justify-center items-start p-4 gap-4 w-full">
            <ChartArea background="transparent"
                // width={1200}
                height={700}
            />
            <ChartTitle text={motor} color="#fff" font="18px Mulish" />
            <ChartLegend
                position="bottom"
                labels={{ font: "16px Mulish", color: "#fff" }}
            />
            <ChartSeries>
                <ChartSeriesItem
                    name={data?.series[0]?.name}
                    type={data?.series[0].type}
                    data={data?.series[0]?.data}
                    xField={data?.series[0].xField}
                    yField={data?.series[0].yField}
                    color={data?.series[0].color}
                    markers={{ visible: true }}
                    width={data?.series[0].width}
                    tooltip={data?.series[0].tooltip}
                />
                <ChartSeriesItem
                    name={data?.series[1]?.name}
                    type={data?.series[1].type}
                    data={data?.series[1]?.data}
                    xField={data?.series[1].xField}
                    yField={data?.series[1].yField}
                    color={data?.series[1].color}
                    markers={{ visible: true }}
                    width={data?.series[1].width}
                    tooltip={data?.series[1].tooltip}
                />
                <ChartSeriesItem
                    name={data?.series[2]?.name}
                    type={data?.series[2].type}
                    data={data?.series[2]?.data}
                    xField={data?.series[2].xField}
                    yField={data?.series[2].yField}
                    color={data?.series[2].color}
                    markers={{ visible: true }}
                    width={data?.series[2].width}
                    tooltip={data?.series[2].tooltip}
                />
                <ChartSeriesItem
                    name={data?.series[3]?.name}
                    type={data?.series[3].type}
                    data={data?.series[3]?.data}
                    xField={data?.series[3].xField}
                    yField={data?.series[3].yField}
                    yAxis={data?.series[3].yAxis}
                    color={data?.series[3].color}
                    markers={{ visible: true }}
                    width={data?.series[3].width}
                    tooltip={data?.series[3].tooltip}
                />
                <ChartSeriesItem
                    name={data?.series[4]?.name}
                    type={data?.series[4].type}
                    data={data?.series[4]?.data}
                    xField={data?.series[4].xField}
                    yField={data?.series[4].yField}
                    color={data?.series[4].color}
                    markers={{ visible: true }}
                    width={data?.series[4].width}
                    tooltip={data?.series[4].tooltip}
                />
                <ChartSeriesItem
                    name={data?.series[5]?.name}
                    type={data?.series[5].type}
                    data={data?.series[5]?.data}
                    xField={data?.series[5].xField}
                    yField={data?.series[5].yField}
                    color={data?.series[5].color}
                    markers={{ visible: true }}
                    width={data?.series[5].width}
                    tooltip={data?.series[5].tooltip}
                    visibleInLegend={false}
                />

            </ChartSeries>
            <ChartXAxis>
                <ChartXAxisItem
                    title={{ text: `PU Motor Horsepower`, font: "16px Mulish", color: "#fff", }}
                    color="#fff"
                    majorGridLines={data?.xAxis[0]?.majorGridLines}
                    minorGridLines={data?.xAxis[0]?.minorGridLines}
                    min={data?.xAxis[0]?.min}
                    axisCrossingValue={[0, 10]}
                />
            </ChartXAxis>
            <ChartYAxis>
                <ChartYAxisItem
                    name="PU_Amps_Volts_PowerFactor_Efficiency"
                    title={{ text: `PU Amps, Volts, Power Factor, Efficiency`, font: "16px Mulish", color: "#fff", }}
                    min={data?.yAxis[0]?.min}
                    max={data?.yAxis[0]?.max}
                    color="#fff"
                    majorGridLines={data?.yAxis[0]?.majorGridLines}
                    minorGridLines={data?.yAxis[0]?.minorGridLines}

                />
                <ChartYAxisItem
                    name="RPM"
                    title={{ text: `RPM`, font: "16px Mulish", color: "#fff", }}
                    color="#fff"
                    majorGridLines={{ width: 0.8, color: "#A0A0A0", visible: false }}
                    minorGridLines={{ width: 0.3, color: "#A0A0A0", visible: true }}
                    majorUnit={80}
                />
            </ChartYAxis>
            <ChartTooltip visible={true} format="{0} {1}" />
        </Chart>
    );
};

export default React.memo(MotorPerformanceGraph);
